// True when a URL is present and uses an http(s) scheme. Mirrors the backend
// admin-feed-update validation (`/^https?:\/\/.+/` in rest-schema.conversion.ts):
// feeds without a real site URL must not be accepted or cataloged.
export const isHttpUrl = (url: string | undefined | null): boolean => !!url && /^https?:\/\/.+/i.test(url);

// True when a URL's host is youtube.com or any subdomain of it (e.g. www.youtube.com).
// YouTube channel feeds are auto-approved during admin review and never categorized.
export const isYoutubeUrl = (url: string | undefined | null): boolean => {
  if (!url) return false;
  try {
    const host = new URL(url).hostname.toLowerCase();
    return host == 'youtube.com' || host.endsWith('.youtube.com');
  } catch {
    return false;
  }
};
